module.exports = __webpack_public_path__ + "static/media/cat.dda03ca2.svg";